import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import NavBar from '../../Components/NavBar/navbar';
import FooterSection from '../../Components/Footer/footer';
import { DEVELOPERS } from '../../utils/docsData';
import { THEME, pageBackgroundSx, gridOverlaySx } from '../../theme';

export default function AboutPage() {
    return (
        <Box sx={pageBackgroundSx}>
            <Box sx={gridOverlaySx} />
            <NavBar />
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, pt: 12, pb: 8 }}>
                <Typography variant="overline" sx={{ color: THEME.primary, fontWeight: 'bold', letterSpacing: 2 }}>
                    About EvolveX
                </Typography>
                <Typography variant="h3" fontWeight={800} color={THEME.textMain} sx={{ mb: 2 }}>
                    Biology, robots, art, and games
                </Typography>
                <Typography variant="body1" color={THEME.secondary} sx={{ mb: 4, maxWidth: 800, lineHeight: 1.8 }}>
                    Simulate biological dynamics, plan robot paths, explore generative art, and try arcade agents.
                    Upload Python code, run live experiments, and dig into the docs when you need them.
                </Typography>

                <Typography variant="h5" color={THEME.textMain} fontWeight={700} sx={{ mb: 3 }}>
                    Team
                </Typography>
                <Grid container spacing={3}>
                    {DEVELOPERS.map((dev) => (
                        <Grid item xs={12} md={6} key={dev.email}>
                            <Card
                                sx={{
                                    bgcolor: THEME.cardBg,
                                    border: `1px solid ${THEME.border}`,
                                    borderRadius: '12px',
                                    height: '100%',
                                }}
                            >
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="h6" color={THEME.textMain} fontWeight={700}>
                                        {dev.name}
                                    </Typography>
                                    <Typography variant="subtitle2" color={THEME.primary} sx={{ mb: 1 }}>
                                        {dev.role}
                                    </Typography>
                                    <Typography variant="body2" color={THEME.secondary} sx={{ mb: 2, lineHeight: 1.7 }}>
                                        {dev.bio}
                                    </Typography>
                                    <Typography variant="body2" color={THEME.secondary}>
                                        {dev.email}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <FooterSection />
        </Box>
    );
}
